import React, { Component } from "react";
import AntdDropdown, {DropDownProps} from "antd/lib/dropdown";
import "antd/lib/dropdown/style";

const { Button } = AntdDropdown;

export default class Dropdown extends Component<DropDownProps> {
  static Button = Button;
  render() {
    const { overlay, ...restProps } = this.props;
    return <AntdDropdown overlay={overlay} {...restProps} />;
  }
}


// WEBPACK FOOTER //
// ./src/components/dropdown/index.tsx